import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ImpuestosService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerImpuestos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          impuesto {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  es_adicional
                  es_retenido
                  es_porcentaje
                  valor
                  factor
                  fecha_registro
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.impuesto.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
ImpuestosService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImpuestosService_Factory() { return new ImpuestosService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ImpuestosService, providedIn: "root" });
